var APIProvider = require("./lib/APIProvider");

var SignalsAPIProvider = require("./lib/SignalsAPIProvider");

var APIProviderError = require("./lib/APIProviderError");

var TokenAuth = require("./lib/auth/TokenAuth");

var AnnoymousAuth = require("./lib/auth/AnnoymousAuth");

module.exports = {
  APIProvider: APIProvider,
  SignalsAPIProvider: SignalsAPIProvider,
  TokenAuth: TokenAuth,
  AnnoymousAuth: AnnoymousAuth,
  APIProviderError: APIProviderError
};